'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _constants = require('../lib/constants');

var _calculateSizeCover = require('../lib/calculate-size-cover');

var _calculateSizeFit = require('../lib/calculate-size-fit');

var _mediaServerClient = require('../lib/media-server-client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImgProvider = function (_Component) {
  _inherits(ImgProvider, _Component);

  function ImgProvider() {
    var _temp, _this, _ret;

    _classCallCheck(this, ImgProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.isLoaded = false, _this.getApi = function () {
      var _this$props = _this.props,
          buildPlaceholderSrc = _this$props.buildPlaceholderSrc,
          buildImageSrc = _this$props.buildImageSrc,
          calculateSizeCover = _this$props.calculateSizeCover,
          calculateSizeFit = _this$props.calculateSizeFit,
          renderMode = _this$props.renderMode,
          format = _this$props.format;


      return {
        buildPlaceholderSrc: buildPlaceholderSrc,
        buildImageSrc: buildImageSrc,
        calculateSizeCover: calculateSizeCover,
        calculateSizeFit: calculateSizeFit,
        renderMode: renderMode,
        format: format,
        isLoaded: _this.isLoaded
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ImgProvider.prototype.componentDidMount = function componentDidMount() {
    this.isLoaded = true;
  };

  ImgProvider.prototype.getChildContext = function getChildContext() {
    return {
      imgProviderApi: this.getApi
    };
  };

  ImgProvider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return ImgProvider;
}(_react.Component);

ImgProvider.defaultProps = {
  renderMode: _constants.RENDER_IMAGE,
  calculateSizeCover: _calculateSizeCover.calculateSizeCover,
  calculateSizeFit: _calculateSizeFit.calculateSizeFit,
  buildImageSrc: _mediaServerClient.buildImageSrc,
  buildPlaceholderSrc: _mediaServerClient.buildPlaceholderSrc,
  format: _mediaServerClient.FORMAT_PNG
};

ImgProvider.childContextTypes = {
  imgProviderApi: _propTypes2.default.func.isRequired
};

exports.default = ImgProvider;